import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const CertWrapper = styled.a<{ isDisabled: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  justify-content: start;
  width: 72px;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
    `}
`;

export const Text = styled(Typography)`
  text-align: center;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.primaryBlue};
    margin-top: ${theme.spacing(0.5)};
  `}
`;
